import type { SoilSightStep } from "consts";

export const SOILSIGHT_FLOW_VERSION = "v1";

export const SOILSIGHT_LANDING_STEP = "landing" as const;

export type SoilSightTrackingStep = typeof SOILSIGHT_LANDING_STEP | SoilSightStep;

export const SOILSIGHT_TRACKING_EVENTS = {
  VIRTUAL_PAGE_VIEW: "soilsight_virtual_page_view",
  FLOW_START: "soilsight_flow_start",
  STEP_VIEW: "soilsight_step_view",
  STEP_COMPLETE: "soilsight_step_complete",
  SIGNUP_CLICK: "soilsight_signup_click",
  SIGNUP_SUBMIT: "soilsight_signup_submit",
  SIGNUP_COMPLETE: "soilsight_signup_complete",
  LOGIN_CLICK: "soilsight_login_click",
  LOGIN_SUBMIT: "soilsight_login_submit",
} as const;
